import { render } from "./PreviewAsset.vue?vue&type=template&id=711479f6"
import script from "./PreviewAsset.vue?vue&type=script&lang=js"
export * from "./PreviewAsset.vue?vue&type=script&lang=js"

import "./PreviewAsset.vue?vue&type=style&index=0&id=711479f6&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__